import { Component } from '@angular/core';
import { IAbstractView } from '@core/interfaces';
import { IAppComponent, IAppPresenter, IPage } from './interfaces';
import { AppPresenter } from './app.presenter';

@Component({
	selector: 'app-root',
	templateUrl: 'app.component.html',
	styleUrls: ['app.component.scss'],
	providers: [AppPresenter],
	standalone: false,
})
export class AppComponent extends IAbstractView<IAppPresenter> implements IAppComponent {
	translations = this.presenter.translations;
	isMenuDisabled = this.presenter.isMenuDisabled;
	appPages = this.presenter.appPages;
	userName = this.presenter.userName;
	userEmail = this.presenter.userEmail;
	cart$ = this.presenter.cart$;
	isLoggedInSignal = this.presenter.isLoggedInSignal;
	isCartEmptySignal = this.presenter.isCartEmptySignal;

	constructor(presenter: AppPresenter) {
		super(presenter);
	}

	closeSesion(): void {
		this.presenter.closeSesion();
	}

	async openSignInModal(): Promise<void> {
		await this.presenter.openSignInModal();
	}

	attrLabelSignIn(): string {
		return this.presenter.attrLabelSignIn();
	}

	async hideMenuSidebar(): Promise<void> {
		this.presenter.hideMenuSidebar();
	}

	navigateToUrl(page: IPage): string {
		return this.presenter.navigateToUrl(page);
	}
}
